export default function normalizeInputValue(inputValue: string | null): string {
  return inputValue ? inputValue.toLowerCase() : '';
}
